import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Music = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Music' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,17.9979131 C1,16.8944962 1.88670635,16 2.99810135,16 L9,16 L9,20.0020869 C9,21.1055038 8.11329365,22 7.00189865,22 L2.99810135,22 C1.89458045,22 1,21.1017394 1,20.0020869 L1,17.9979131 Z M15,17.9979131 C15,16.8944962 15.8867064,16 16.9981014,16 L23,16 L23,20.0020869 C23,21.1055038 22.1132936,22 21.0018986,22 L16.9981014,22 C15.8945804,22 15,21.1017394 15,20.0020869 L15,17.9979131 Z M9,16 L9,2 L23,2 L23,15.5 M9,6 L23,6' />
  </StyledIcon>
);
